import React from "react";
import { Checkbox } from "antd";
import type { CheckboxProps } from "antd";
import { SelectedTranslatedTrack } from "providers/AudioProvider/types";
import { AudioTrack } from "providers/AudioProvider/types";

interface SelectCheckboxProps {
    selectedTranslatedTrackIds: SelectedTranslatedTrack[];
    setSelectedTranslatedTrackIds: React.Dispatch<React.SetStateAction<SelectedTranslatedTrack[]>>;
    ind: number;
    track: AudioTrack;
}

export const SelectCheckbox = ({
    selectedTranslatedTrackIds,
    setSelectedTranslatedTrackIds,
    ind,
    track,
}: SelectCheckboxProps) => {
    const onChange: CheckboxProps["onChange"] = (e) => {
        if (e.target.checked) {
            setSelectedTranslatedTrackIds((prev) =>
                [...prev, { ind, track }].sort((a, b) => a.ind - b.ind),
            );
        }
        if (!e.target.checked) {
            setSelectedTranslatedTrackIds((prev) => prev.filter((item) => item.ind !== ind));
        }
    };

    return (
        <Checkbox
            checked={!!selectedTranslatedTrackIds.find((item) => item.ind === ind)}
            onChange={onChange}
        />
    );
};
